/**
 * Pure mapping from Sidebase auth session + optional view-as flag to Sentry.setUser inputs.
 * Used by app `sentry.client.ts` plugins; testable without Nuxt or Sentry.init.
 */
export type SentryUserSyncResult =
  | { kind: 'clear' }
  | {
      kind: 'set'
      user: { email: string } | { email: string; currentlyViewingAsUser: true }
    }
  | { kind: 'noop' }

export function getSentryUserSyncResult(input: {
  status: string
  email?: string | null
  currentlyViewingAsUser?: boolean | null
}): SentryUserSyncResult {
  const { status, email, currentlyViewingAsUser } = input

  if (status === 'unauthenticated') {
    return { kind: 'clear' }
  }

  if (status === 'authenticated' && email) {
    if (currentlyViewingAsUser === true) {
      return {
        kind: 'set',
        user: { email, currentlyViewingAsUser: true },
      }
    }
    return { kind: 'set', user: { email } }
  }

  return { kind: 'noop' }
}
